// extracted by mini-css-extract-plugin
export var dateLabel = "_3b-0";
export var dateLabelError = "_3b-1";
export var fullWidth = "_3b-2";
export var smaller = "_3b-3";